import React from 'react'

import ListItem from './ListItem'

const Header = props => {
  return (
    <ListItem>
      <span pos='left'>
        Size
      </span>
      <span pos='center'>
        Resolution
      </span>
      <span pos='center'>
        Refresh Rate (Hz)
      </span>
      <span pos='center'>
        Vendor
      </span>
      <span pos='right'>
        Part Number
      </span>
    </ListItem>
  )
}

export default Header
